<template>
    <v-img
        :src="background"
        width="100%"
        height="calc(100vh - 75px)"
    >
        
        <title>Main Page</title>
        <div
            style="margin-top:calc(30vh - 250px);"
        >
            <v-img
                v-if="processEnv.VUE_APP_ENV !== 'prod'"
                style="position:fixed;top:8px;left:0;right:0;margin:0 auto;"
                width="250"
                height="60"
                src="@/assets/testing.png"
            ></v-img>
            <!-- <v-img
                v-if="processEnv.VUE_APP_ENV === 'prod'"
                style="position:fixed;top:0px;left:0;right:0;margin:0 auto;"
                width="350"
                height="115"
                src="@/assets/notice.png"
            ></v-img> -->
            <v-img
                style="position:absolute;top:0"
                width="330"
                height="100"
                src="@/assets/Revelio new.png"
            ></v-img>
            <v-row
                style="width:1200px; margin: 0 auto;"
                class="d-flex align-center justify-center"
            >
                <v-col
                    v-for="n in 9"
                    :key="n"
                    cols="4"
                >
                    <module-btn
                        v-if="n == 1 && user.Role < 4"
                        :img="revelio"
                        title="Revelio Planning"
                        instruction=""
                        to="/op/tables/op"
                    >
                    </module-btn>
                    <module-btn
                        v-else-if="n == 1 && user.ci_Role < 4"
                        :img="revelio"
                        title="Revelio Planning"
                        instruction=""
                        to="/op/tables/ci-op"
                    >
                    </module-btn>
                    <!-- <module-btn
                        v-else-if="n == 1 && user.bases_Role < 4"
                        :img="revelio"
                        title="Revelio Planning"
                        instruction=""
                        to="/op/tables/bases-op"
                    >
                    </module-btn> -->
                    <v-spacer></v-spacer>
                    <module-btn
                        v-if="n == 2"
                        :img="rct"
                        title="Revelio Forecasting"
                        instruction=""
                        :href="processEnv.VUE_APP_RCT_REDIRECT"
                    >
                    </module-btn>
                    <module-btn
                        v-if="blackboxRole && n == 3"
                        icon="mdi-chart-donut-variant"
                        title="Revelio Blackbox"
                        instruction=""
                        :href="processEnv.VUE_APP_BLACKBOX_REDIRECT"
                    >
                    </module-btn>
                    <module-btn
                        v-if="massuploadRole && n == 4"
                        icon="mdi-clock-edit-outline"
                        title="Revelio Mass Upload"
                        instruction=""
                        to="/op/tables/massupload"
                    >
                    </module-btn>
                    <module-btn
                        v-else-if="!massuploadRole && ci_massuploadRole && n == 4"
                        icon="mdi-clock-edit-outline"
                        title="Revelio Mass Upload (GFK)"
                        instruction=""
                        to="/op/tables/ci-massupload"
                    >
                    </module-btn>
                    <module-btn
                        v-if="n == 5"
                        :img="whitespace"
                        title="Revelio Whitespace (WIP)"
                        instruction=""
                        href="https://app.powerbi.com/groups/me/apps/d9f89572-5425-4a4f-a9ec-a5fa0b31c297/reports/f1bb750a-9db1-4c31-a2ed-1897aeac890a/ReportSection7c763ae6910a84c99366"
                    >
                    </module-btn>
                    <module-btn
                        v-if="n == 6"
                        icon="mdi-alpha-s-circle-outline"
                        title="Revelio SIP"
                        instruction=""
                        href="https://connect-incentiveiq-prod.uc.r.appspot.com"
                    >
                    </module-btn>
                    <module-btn
                        v-if="n == 7"
                        icon="mdi-human-edit"
                        title="Revelio Mapping Management"
                        instruction=""
                        :href="processEnv.VUE_APP_RMM_REDIRECT"
                    >
                    </module-btn>
                </v-col>
            </v-row>
        </div>
    </v-img>
</template>

<script>
    import moduleBtn from './module-btn'
    import { mapState } from 'vuex'
    import { xPost } from '@/http/axios'
    export default {
        components: {
            moduleBtn
        },

        data () {
            return {
                blackboxRole: false,
                massuploadRole: false,
                ci_massuploadRole: false,
                userInfo: [],
                background: require('@/assets/mainback.png'),
                revelio: require('@/assets/RP new.png'),
                rct: require('@/assets/RF new.png'),
                testing: require('@/assets/testing.png'),
                whitespace: require('@/assets/whitespace-new.png'),
            }
        },
        beforeMount () {
            // this.getUser()
            this.getRole()
            // console.log(this.processEnv)
        },

        computed: {
            ...mapState([
                // 'gapi',
                'user'
            ]),
            processEnv () {
                return process.env
            },
        },

        methods: {
            // async getUser () {
            //     try {
            //         const req = xPost(
            //         'list',
            //         'getUser',
            //         {
            //             userinfo: this.userInfo
            //         })
            //         const res = await req
            //         if (res.status === 200 && res.data.status === 200) {
            //             userRole = res.data.role.Role
            //         }
            //     } catch (err) {
            //         console.log(err)
            //         this.snackbarMassage = '1233'
            //         this.snackbar = true
            //         this.snackbarColor = 'error'
            //         this.comfirmUploading = false
            //     }
            // },
            async getRole () {
                const params = {
                    useremail: this.user.email
                }
                try {
                    const res = await xPost(
                    'massuploadaccess',
                    'massuploadRole',
                    params
                    )
                    if (res.status === 200 && (res.data.massuploadRole || res.data.massuploadCiRole) && res.data.massuploadMaintain  == '0') {
                        if (res.data.massuploadRole.Role == '1' || res.data.massuploadRole.Role == '2') {
                            this.massuploadRole = true
                        } else if (res.data.massuploadCiRole.Role == '1' || res.data.massuploadCiRole.Role == '2'){
                            this.ci_massuploadRole = true
                        }
                    }
                } catch (err) {
                    console.log("can't get user Role")
                    console.log(err)
                }
                try {
                    const res = await xPost(
                    'blackboxaccess',
                    'blackboxRole',
                    params
                    )
                    if (res.status === 200 && res.data.blackboxRole && res.data.blackbox_status.status == "0") {
                        this.blackboxRole = true
                    }
                } catch (err) {
                    console.log("can't get user Role")
                    console.log(err)
                }
            }
        }

    }
</script>

<style>
    /* ::-webkit-scrollbar {
        width: 0 !important;
    } */
    html { overflow-y: auto !important;; }
</style>